import { render, staticRenderFns } from "./court.vue?vue&type=template&id=18d1330a&scoped=true"
import script from "./court.vue?vue&type=script&lang=js"
export * from "./court.vue?vue&type=script&lang=js"
import style0 from "./court.vue?vue&type=style&index=0&id=18d1330a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d1330a",
  null
  
)

export default component.exports